const PATHS = {
  HOME_PAGE: "/",
};

export { PATHS };
